import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

//import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";


import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

//import { OidcProvider } from "redux-oidc";
//import userManager from "./util/userManager";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./util/authConfig";
const msalInstance = new PublicClientApplication(msalConfig);

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.

const store = configureStore(history);


ReactDOM.render(
    <Provider store={store}>
        <MsalProvider instance={msalInstance}>
           
                <App />

        </MsalProvider>
    </Provider>,
    document.getElementById('root'));

//registerServiceWorker();
